// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.scaledImageItem[data-v-671fd125]
	{
		border: 10px solid #FFFFFF;
		box-shadow: 1px 1px 3px 2px rgba(0,0,0,1);
		padding: 10px;
		margin: 5px;
		cursor: pointer;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: flex-start;
}
.scaledImageItem[data-v-671fd125]:focus
		{
			outline: 8px solid #0000FF80;
}
.scaledImageItem[data-v-671fd125]:hover
		{
			outline: 8px solid #0080FF80;
}
.scaledImageItem.selected[data-v-671fd125]
		{
			border-color: #6666FF;
			cursor: default;
}
.caption[data-v-671fd125]
	{
		text-align: center;
		text-decoration: none;
		word-break: break-word;
		max-width: 220px;
}
.caption[data-v-671fd125] > *
		{
			display: block;
			max-width: 220px;
			white-space: pre-line;
			text-decoration: none;
}
.caption a[data-v-671fd125]:hover,
		.caption a[data-v-671fd125]:focus
		{
			text-decoration: underline;
}
.download_img[data-v-671fd125]
	{
		fill: currentColor;
		height: 1em;
		width: 1em;
		vertical-align: text-bottom;
		transform: rotate(180deg);
}
`, "",{"version":3,"sources":["webpack://./www/vues/client/controls/ImageOptimizerImage.vue"],"names":[],"mappings":";AAsDC;;EAEC,0BAA0B;EAC1B,yCAAyC;EACzC,aAAa;EACb,WAAW;EACX,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;AAC5B;AAEC;;GAEC,4BAA4B;AAC7B;AAEA;;GAEC,4BAA4B;AAC7B;AAEA;;GAEC,qBAAqB;GACrB,eAAe;AAChB;AAED;;EAEC,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,gBAAgB;AACjB;AAEC;;GAEC,cAAc;GACd,gBAAgB;GAChB,qBAAqB;GACrB,qBAAqB;AACtB;AAEA;;;GAGC,0BAA0B;AAC3B;AAED;;EAEC,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,2BAA2B;EAC3B,yBAAyB;AAC1B","sourcesContent":["<template>\r\n\t<div class=\"scaledImageItem\" :class=\"{ selected: selected }\" role=\"button\" tabindex=\"0\" @click=\"selectImage(img)\" @keypress.enter.space.prevent=\"selectImage(img)\">\r\n\t\t<img :src=\"dataUri\" alt=\"image\" class=\"scaledImage\" />\r\n\t\t<div class=\"caption\">\r\n\t\t\t<a :href=\"dataUri\" :download=\"downloadName\" title=\"download image\">{{downloadName}} <vsvg sprite=\"upload\" class=\"download_img\" /></a>\r\n\t\t\t<div>{{fileSize}}</div>\r\n\t\t</div>\r\n\t</div>\r\n</template>\r\n\r\n<script>\r\n\timport svg1 from 'appRoot/images/sprite/upload.svg';\r\n\timport { formatBytesF10 } from 'appRoot/scripts/Util';\r\n\r\n\texport default {\r\n\t\temits: ['select'],\r\n\t\tcomponents: {},\r\n\t\tprops:\r\n\t\t{\r\n\t\t\timg: {\r\n\t\t\t\ttype: Object,\r\n\t\t\t\trequired: true\r\n\t\t\t},\r\n\t\t\tselected: {\r\n\t\t\t\ttype: Boolean,\r\n\t\t\t\tdefault: false\r\n\t\t\t}\r\n\t\t},\r\n\t\tcomputed:\r\n\t\t{\r\n\t\t\tfileSize()\r\n\t\t\t{\r\n\t\t\t\treturn formatBytesF10(this.img.ByteLength, 2);\r\n\t\t\t},\r\n\t\t\tdownloadName()\r\n\t\t\t{\r\n\t\t\t\treturn this.img.Name + this.img.FileExtension;\r\n\t\t\t},\r\n\t\t\tdataUri()\r\n\t\t\t{\r\n\t\t\t\treturn 'data:' + this.img.ContentType + ';base64,' + this.img.DataBase64;\r\n\t\t\t}\r\n\t\t},\r\n\t\tmethods:\r\n\t\t{\r\n\t\t\tselectImage(img)\r\n\t\t\t{\r\n\t\t\t\tthis.$emit(\"select\", { img });\r\n\t\t\t},\r\n\t\t}\r\n\t}\r\n</script>\r\n\r\n<style scoped>\r\n\t.scaledImageItem\r\n\t{\r\n\t\tborder: 10px solid #FFFFFF;\r\n\t\tbox-shadow: 1px 1px 3px 2px rgba(0,0,0,1);\r\n\t\tpadding: 10px;\r\n\t\tmargin: 5px;\r\n\t\tcursor: pointer;\r\n\t\tdisplay: flex;\r\n\t\tflex-direction: column;\r\n\t\talign-items: center;\r\n\t\tjustify-content: flex-start;\r\n\t}\r\n\r\n\t\t.scaledImageItem:focus\r\n\t\t{\r\n\t\t\toutline: 8px solid #0000FF80;\r\n\t\t}\r\n\r\n\t\t.scaledImageItem:hover\r\n\t\t{\r\n\t\t\toutline: 8px solid #0080FF80;\r\n\t\t}\r\n\r\n\t\t.scaledImageItem.selected\r\n\t\t{\r\n\t\t\tborder-color: #6666FF;\r\n\t\t\tcursor: default;\r\n\t\t}\r\n\r\n\t.caption\r\n\t{\r\n\t\ttext-align: center;\r\n\t\ttext-decoration: none;\r\n\t\tword-break: break-word;\r\n\t\tmax-width: 220px;\r\n\t}\r\n\r\n\t\t.caption > *\r\n\t\t{\r\n\t\t\tdisplay: block;\r\n\t\t\tmax-width: 220px;\r\n\t\t\twhite-space: pre-line;\r\n\t\t\ttext-decoration: none;\r\n\t\t}\r\n\r\n\t\t.caption a:hover,\r\n\t\t.caption a:focus\r\n\t\t{\r\n\t\t\ttext-decoration: underline;\r\n\t\t}\r\n\r\n\t.download_img\r\n\t{\r\n\t\tfill: currentColor;\r\n\t\theight: 1em;\r\n\t\twidth: 1em;\r\n\t\tvertical-align: text-bottom;\r\n\t\ttransform: rotate(180deg);\r\n\t}\r\n</style>"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
